module.exports = __webpack_public_path__ + "media/scripts/pages/join/assets/media/benefits/viral-engine-711007f31b87410c47647ead10e19fa9.svg";